// Feature flags. One switch per capability that is built but deliberately not
// exposed yet. Flip the flag, get the capability back. Nothing is deleted.
//
// CLIENT_PORTAL — the four client-facing screens: Account, Usage, Documents,
// Webhooks. Clients do not log in to Sonar today, so these had no audience and
// their nav items pointed at CrmPlaceholder. With the flag false the nav items
// are hidden and the routes redirect to wherever that capability now lives:
//   account   -> Client profile  (client details moved there, 25 Sep)
//   usage     -> Performance     (spend and volume per client, 27 Sep)
//   documents -> Home            (no home for documents yet; it belongs in the
//                                 operator shell beside Clients, not per-client)
//   webhooks  -> Home            (outbound webhooks have no subscribers yet; the
//                                 events exist and fire, see server/webhooks.js)
//
// Set this to true to restore all four exactly as they were. Nothing else needs
// changing in the nav or the router. Still on disk and untouched:
//   client/src/screens/Webhooks.js, AdminWebhooks.js, WebhooksDocs.js
//   every backend route in server/webhooks.js
//
// Before turning it on: tenant isolation is a hard prerequisite. scopeToClient
// in server/auth.js is written but applied to zero of the routes that take a
// client id, so a client user could read another client's data by changing the
// URL. Fix that globally first.
export const CLIENT_PORTAL = false;
